import React, { Fragment } from "react";
import { string, func, any } from "prop-types";
import * as styles from "./styles.module.scss";

const NumberFieldGroup = ({
  placeholder,
  value,
  type,
  onChange = () => {},
}) => {
  return (
    <Fragment>
      <div className="register_field form-control ">
        <div className={styles.input}>
          <input
            type={type}
            className={styles.resetInput}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
          />
        </div>
      </div>
    </Fragment>
  );
};

NumberFieldGroup.propTypes = {
  type: string.isRequired,
  onChange: func.isRequired,
  placeholder: string,
  value: any,
};

NumberFieldGroup.defaultProps = {
  type: "number",
};

export default NumberFieldGroup;
